import styled from 'styled-components';
import { statusCountAccent } from '../../Deliveries/statusCountColors';

export const MetricPanel = styled.section`
    background: #fff;
    border: 1px solid ${({ theme }) => theme.colors?.gray?.[200] || '#e2e8f0'};
    border-radius: 12px;
    padding: clamp(16px, 3vw, 24px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    min-width: 0;
`;

export const MetricPanelHeader = styled.header`
    margin-bottom: 16px;
`;

export const MetricPanelTitle = styled.h2`
    font-size: clamp(1rem, 2.5vw, 1.125rem);
    font-weight: 600;
    color: ${({ theme }) => theme.colors?.gray?.[900] || '#1a202c'};
    margin: 0 0 4px;
`;

export const MetricPanelDescription = styled.p`
    margin: 0;
    font-size: 14px;
    color: ${({ theme }) => theme.colors?.gray?.[600] || '#718096'};
    line-height: 1.45;
`;

export const MetricPanelMeta = styled.p`
    margin: 8px 0 0;
    font-size: 12px;
    color: ${({ theme }) => theme.colors?.gray?.[500] || '#a0aec0'};
`;

export const MetricEmptyState = styled.p`
    margin: 0;
    font-size: 14px;
    color: ${({ theme }) => theme.colors?.gray?.[600] || '#718096'};
`;

export const KpiGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 180px), 1fr));
    gap: clamp(12px, 2vw, 16px);
`;

export const KpiCard = styled.div`
    background: ${({ theme }) => theme.colors?.gray?.[50] || '#f9fafb'};
    border: 1px solid ${({ theme }) => theme.colors?.gray?.[200] || '#e5e7eb'};
    border-radius: 10px;
    padding: 16px;
    min-width: 0;
`;

export const KpiLabel = styled.p`
    margin: 0 0 8px;
    font-size: 13px;
    color: ${({ theme }) => theme.colors?.gray?.[600] || '#718096'};
`;

export const KpiValue = styled.p`
    margin: 0;
    font-size: clamp(1.25rem, 4vw, 1.75rem);
    font-weight: 600;
    color: ${({ theme }) => theme.colors?.gray?.[900] || '#1a202c'};
    word-break: break-word;
`;

export const KpiHint = styled.p`
    margin: 6px 0 0;
    font-size: 12px;
    color: ${({ theme }) => theme.colors?.gray?.[500] || '#a0aec0'};
`;

export const ChartWrap = styled.div`
    width: 100%;
    min-height: ${({ $minHeight }) => $minHeight || '220px'};
    min-width: 0;
`;

export const StatusCountsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 9.5rem), 1fr));
    gap: 10px;
`;

export const ReadOnlyStatusCountCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    min-height: 4.5rem;
    padding: 10px 12px 10px 14px;
    border-radius: 8px;
    border: 2px solid ${({ theme }) => theme.colors?.gray?.[200] || '#e0e0e0'};
    background: #fff;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        left: 5px;
        top: 8px;
        bottom: 8px;
        width: 3px;
        border-radius: 3px;
        background: ${({ theme, $colorToken }) => statusCountAccent(theme, $colorToken)};
    }
`;

export const StatusCountLabel = styled.span`
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors?.gray?.[700] || '#4a5568'};
    line-height: 1.3;
`;

export const StatusCountValue = styled.span`
    font-size: 1.25rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors?.gray?.[900] || '#1a202c'};
`;

export const UnknownTypeNotice = styled.p`
    margin: 0;
    font-size: 14px;
    color: ${({ theme }) => theme.colors?.warning?.dark || '#92400e'};
`;
